import React from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import "./Project.css";

export default class Project extends React.Component {
  constructor() {
    super();
    this.state = {
      project: null,
      loaded: false,
      articles: []
    };

    axios
      .get(process.env.REACT_APP_API_URL + "/project/newyearinlibraries")
      .then(({ data }) => {
        this.setState({
          project: data.response.project,
          loaded: true,
          articles: data.response.articles
        });
        console.log(this.state.project);
      });
  }

  render() {
    return !this.state.loaded ? (
      ""
    ) : (
      <div className="content">
        <div className="project">
          <div className="artical-title" style={{ marginBottom: "36px" }}>
            {this.state.project.title}
          </div>
          <div
            className="article"
            dangerouslySetInnerHTML={{ __html: this.state.project.description }}
          />
        </div>
        <div className="row">
          {this.state.articles.map((col, index) => {
            if (col.url.search(/youtube/) !== -1) {
              return (
                <div
                  key={index}
                  className={`cell width-${col.position.length} order-${
                    col.position.position
                  }`}
                >
                  <button
                    className="shadow card-link"
                    onClick={() => this.openYoutubePopup(col.content)}
                  />
                  <div className={`height-${col.height_style}`}>
                    <div
                      className="image"
                      style={{
                        backgroundImage: `url(${process.env.REACT_APP_IMG_SERVER}/img/${
                          col.image_id
                        }/mobile)`,
                        backgroundSize: "cover"
                      }}
                    />
                  </div>
                  <div
                    className="card-info-over"
                    onClick={() => this.openYoutubePopup(col.content)}
                  >
                    <div> {col.title} </div>
                  </div>
                </div>
              );
            } else {
              return (
                <div key={index} className={`cell width-2 order-1`}>
                  <a
                    className={
                      col.height_style === 1 ? "shadow card-link" : "card-link"
                    }
                    href={`/articles/${col.rubric}`}
                  >
                    {col.url}
                  </a>
                  <div className={`height-${col.height_style}`}>
                    <div
                      className="image"
                      style={{
                        backgroundImage: `url(${process.env.REACT_APP_IMG_SERVER}/img/${
                          col.image
                        }/mobile)`,
                        backgroundSize: "cover"
                      }}
                    />
                  </div>
                  {col.height_style === 1 ? (
                    <a
                      href={`/articles/${col.rubric}`}
                      className="card-info-over"
                    >
                      <div> {col.title} </div>
                      <div> {col.content} </div>
                    </a>
                  ) : (
                    <div className="card-info-under">
                      <div>
                        <Link
                          className="category-link-under"
                          to={{ pathname: `/articles/${col.rubric}` }}
                        >
                          {" "}
                          {col.rubric
                            ? col.rubric[0].toUpperCase() + col.rubric.slice(1)
                            : ""}{" "}
                        </Link>
                      </div>
                      <div> {col.content} </div>
                    </div>
                  )}
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Project/Project.js